/* @flow */

import type { FormData } from "@awardit/formaggio/src/types";

import React from "react";
import { useTranslate } from "@awardit/react-use-translate";
import { default as AddressComponent, ContactInfo } from "components/Address";
import { Foldable } from "@crossroads/ui-components";
import Button from "components/Button";
import { Box, BoxHeader, BoxBody } from "components/Box";

import styles from "./styles.scss";

type Props = {
  state: FormData,
  editing: boolean,
  setEditing: boolean => void,
  setCustomerCountry: string => void,
};

const Addresses = ({ state, editing, setEditing, setCustomerCountry }: Props): React$Node => {
  const t = useTranslate();

  const onClickToggle = (e: MouseEvent) => {
    e.preventDefault();
    setEditing(!editing);
  };

  return (
    <div>
      <Box>
        <BoxHeader>
          <h2>{t("CHECKOUT.ADDRESSES_TITLE")}</h2>
          <Button className="link" size="small" onClick={onClickToggle}>
            {editing ? t("CHECKOUT.ADDRESS_MINIMIZE") : t("CHECKOUT.EDIT_ADDRESS")}
          </Button>
        </BoxHeader>
        <Foldable open={!editing}>
          <BoxBody className={styles.preview}>
            <div>
              <p className={styles.minimizedName}>
                {String(state.firstname)} {String(state.lastname)}
              </p>
              <p className={styles.minimizedInfo}>
                {Object.values(state.street).join(", ")}
                <br />
                {String(state.postcode)} {String(state.city)}
                <br />
                {String(state.telephone)}
                <br />
                {String(state.email)}
              </p>
            </div>
          </BoxBody>
        </Foldable>
        <Foldable open={editing}>
          <BoxBody className={styles.editing}>
            <div className={styles.row}>
              <ContactInfo />
            </div>
            <div className={styles.row}>
              <h2>{t("CHECKOUT.ADDRESS.ADDRESS")}</h2>
              <AddressComponent
                setCustomerCountry={(country: string) => {
                  setCustomerCountry(country);
                }}
              />
            </div>
          </BoxBody>
        </Foldable>
      </Box>
    </div>
  );
};

export default Addresses;
